<div
	class="p-1 flex scrollbar-fade overflow-auto rounded-1 max-h-full bg-180 shadow-z-menu flex-col items-start justify-start"
	[class.w-full]="!widthSmallMenu"
	[class.min-w-27]="widthSmallMenu"
	[class.w-27]="widthSmallMenu"
>
	<ng-content></ng-content>
</div>
